// extracted by mini-css-extract-plugin
export var section = "arrow-module--section--1Mxyh";
export var arrow = "arrow-module--arrow--2lqqF";